import axios from 'axios';
import { adminMainUrl } from '../../../Config';

// unused Quotation list
export const fetchUnusedQuotationListRequest = () => ({
    type: "FIND_UNUSED_QUOTATION_LIST_REQUEST",
});

export const fetchUnusedQuotationListSuccess = (data) => ({
    type: "FIND_UNUSED_QUOTATION_LIST_SUCCESS",
    payload: data,
});

export const fetchUnusedQuotationListFailure = (error) => ({
    type: "FIND_UNUSED_QUOTATION_LIST_FAILURE",
    payload: error,
});

export const getUnusedQuotationList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchUnusedQuotationListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/unused-final-quotation`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchUnusedQuotationListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getUnusedQuotationList function (redux):", err);
                dispatch(fetchUnusedQuotationListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getUnusedQuotationList function:", error);
            dispatch(fetchUnusedQuotationListFailure(error));
        }
    };
};

// unused Quotation list

// job order list
export const fetchJobOrderListRequest = () => ({
    type: "FIND_JOBORDER_LIST_REQUEST",
});

export const fetchJobOrderListSuccess = (data) => ({
    type: "FIND_JOBORDER_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderListFailure = (error) => ({
    type: "FIND_JOBORDER_LIST_FAILURE",
    payload: error,
});

export const getJobOrderList = (token, user_id, trans_mode, service_type, impexp, current_page, queryParams) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderListRequest());

        let params = new URLSearchParams(queryParams);
        let requestBody = {
            search_text: "",
            trans_mode: "",
            trans_type: "",
            page: current_page,
        };
        params.forEach((value, key) => {
            requestBody[key] = value;
        });

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/jobOrder/list`;
        if (trans_mode && service_type && impexp) {
            let cc_ff;
            let imp_exp;
            let t_mode = trans_mode.toLowerCase();
            if (service_type == "custom_clearance") { cc_ff = "cc" };
            if (service_type == "freight_forwarding") { cc_ff = "ff" };
            if (impexp == "importer") { imp_exp = "imp" };
            if (impexp == "exporter") { imp_exp = "exp" };
            apiUrl = `${adminMainUrl}/api/jobOrder/list/${cc_ff}/${t_mode}/${imp_exp}`;
        } else {
            apiUrl = `${adminMainUrl}/api/jobOrder/list`;
        }

        try {
            axios.post(apiUrl, requestBody, config).then((res) => {
                dispatch(fetchJobOrderListSuccess(res.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderList function (redux):", err);
                dispatch(fetchJobOrderListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderList function:", error);
            dispatch(fetchJobOrderListFailure(error));
        }
    };
};

// job order list

// User list
export const fetchJobOrderEmployeeListRequest = () => ({
    type: "FIND_JOBORDER_EMPLOYEE_LIST_REQUEST",
});

export const fetchJobOrderEmployeeListSuccess = (data) => ({
    type: "FIND_JOBORDER_EMPLOYEE_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderEmployeeListFailure = (error) => ({
    type: "FIND_JOBORDER_EMPLOYEE_LIST_FAILURE",
    payload: error,
});

export const getJobOrderEmployeeList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderEmployeeListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/employee-list`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderEmployeeListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderEmployeeList function (redux):", err);
                dispatch(fetchJobOrderEmployeeListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderEmployeeList function:", error);
            dispatch(fetchJobOrderEmployeeListFailure(error));
        }
    };
};


// User list

// job order details
export const fetchJobOrderDetailsRequest = () => ({
    type: "FIND_JOBORDER_DETAIL_REQUEST",
});

export const fetchJobOrderDetailsSuccess = (data) => ({
    type: "FIND_JOBORDER_DETAIL_SUCCESS",
    payload: data,
});

export const fetchJobOrderDetailsFailure = (error) => ({
    type: "FIND_JOBORDER_DETAIL_FAILURE",
    payload: error,
});

export const getJobOrderDetails = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderDetailsRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/view`;

        let body = { id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderDetailsSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderDetails function (redux):", err);
                dispatch(fetchJobOrderDetailsFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderDetails function:", error);
            dispatch(fetchJobOrderDetailsFailure(error));
        }
    };
};

// job order details

// job order service details
export const fetchJobOrderServiceDetailsRequest = () => ({
    type: "FIND_JOBORDER_SERVICE_DETAIL_REQUEST",
});

export const fetchJobOrderServiceDetailsSuccess = (data) => ({
    type: "FIND_JOBORDER_SERVICE_DETAIL_SUCCESS",
    payload: data,
});

export const fetchJobOrderServiceDetailsFailure = (error) => ({
    type: "FIND_JOBORDER_SERVICE_DETAIL_FAILURE",
    payload: error,
});

export const getJobOrderServiceDetails = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderServiceDetailsRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/service/details`;

        let body = { job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderServiceDetailsSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderServiceDetails function (redux):", err);
                dispatch(fetchJobOrderServiceDetailsFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderServiceDetails function:", error);
            dispatch(fetchJobOrderServiceDetailsFailure(error));
        }
    };
};

// job order service details


// job order service details
export const fetchJobOrderCustomerListRequest = () => ({
    type: "FIND_JOBORDER_CUSTOMER_LIST_REQUEST",
});

export const fetchJobOrderCustomerListSuccess = (data) => ({
    type: "FIND_JOBORDER_CUSTOMER_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderCustomerListFailure = (error) => ({
    type: "FIND_JOBORDER_CUSTOMER_LIST_FAILURE",
    payload: error,
});

export const getJobOrderCustomerList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCustomerListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/get-all-approved-customers`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderCustomerListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderCustomerList function (redux):", err);
                dispatch(fetchJobOrderCustomerListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderCustomerList function:", error);
            dispatch(fetchJobOrderCustomerListFailure(error));
        }
    };
};

// job order service details



// job order entity details
export const fetchJobOrderEntityDetailsRequest = () => ({
    type: "FIND_JOBORDER_ENTITY_DETAIL_REQUEST",
});

export const fetchJobOrderEntityDetailsSuccess = (data) => ({
    type: "FIND_JOBORDER_ENTITY_DETAIL_SUCCESS",
    payload: data,
});

export const fetchJobOrderEntityDetailsFailure = (error) => ({
    type: "FIND_JOBORDER_ENTITY_DETAIL_FAILURE",
    payload: error,
});

export const getJobOrderEntityDetails = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderEntityDetailsRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/entity/details`;

        let body = { job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderEntityDetailsSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderEntityDetails function (redux):", err);
                dispatch(fetchJobOrderEntityDetailsFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderEntityDetails function:", error);
            dispatch(fetchJobOrderEntityDetailsFailure(error));
        }
    };
};

// job order entity details

// job order entity details
export const fetchJobOrderCustomsDetailsRequest = () => ({
    type: "FIND_JOBORDER_CUSTOMS_DETAIL_REQUEST",
});

export const fetchJobOrderCustomsDetailsSuccess = (data) => ({
    type: "FIND_JOBORDER_CUSTOMS_DETAIL_SUCCESS",
    payload: data,
});

export const fetchJobOrderCustomsDetailsFailure = (error) => ({
    type: "FIND_JOBORDER_CUSTOMS_DETAIL_FAILURE",
    payload: error,
});

export const getJobOrderCustomsDetails = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCustomsDetailsRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/custom/details`;

        let body = { job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderCustomsDetailsSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderCustomsDetails function (redux):", err);
                dispatch(fetchJobOrderCustomsDetailsFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderCustomsDetails function:", error);
            dispatch(fetchJobOrderCustomsDetailsFailure(error));
        }
    };
};

// job order entity details

// job order custom house
export const fetchJobOrderCustomsHouseListRequest = () => ({
    type: "FIND_JOBORDER_CUSTOMS_HOUSE_LIST_REQUEST",
});

export const fetchJobOrderCustomsHouseListSuccess = (data) => ({
    type: "FIND_JOBORDER_CUSTOMS_HOUSE_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderCustomsHouseListFailure = (error) => ({
    type: "FIND_JOBORDER_CUSTOMS_HOUSE_LIST_FAILURE",
    payload: error,
});

export const getJobOrderCustomsHouseList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCustomsHouseListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/custom-house/get`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderCustomsHouseListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderCustomsHouseList function (redux):", err);
                dispatch(fetchJobOrderCustomsHouseListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderCustomsHouseList function:", error);
            dispatch(fetchJobOrderCustomsHouseListFailure(error));
        }
    };
};

// job order custom house

// job order exim scheme
export const fetchJobOrderEximSchemeListRequest = () => ({
    type: "FIND_JOBORDER_EXIM_SCHEME_LIST_REQUEST",
});

export const fetchJobOrderEximSchemeListSuccess = (data) => ({
    type: "FIND_JOBORDER_EXIM_SCHEME_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderEximSchemeListFailure = (error) => ({
    type: "FIND_JOBORDER_EXIM_SCHEME_LIST_FAILURE",
    payload: error,
});

export const getJobOrderEximSchemeList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderEximSchemeListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/exim-scheme/get`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderEximSchemeListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderEximSchemeList function (redux):", err);
                dispatch(fetchJobOrderEximSchemeListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderEximSchemeList function:", error);
            dispatch(fetchJobOrderEximSchemeListFailure(error));
        }
    };
};

// job order exim scheme

// job order port
export const fetchJobOrderPortListRequest = () => ({
    type: "FIND_JOBORDER_PORT_LIST_REQUEST",
});

export const fetchJobOrderPortListSuccess = (data) => ({
    type: "FIND_JOBORDER_PORT_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderPortListFailure = (error) => ({
    type: "FIND_JOBORDER_PORT_LIST_FAILURE",
    payload: error,
});

export const getJobOrderPortList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderPortListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/port/list`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderPortListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderPortList function (redux):", err);
                dispatch(fetchJobOrderPortListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderPortList function:", error);
            dispatch(fetchJobOrderPortListFailure(error));
        }
    };
};

// job order port

// job order airport
export const fetchJobOrderAirportListRequest = () => ({
    type: "FIND_JOBORDER_AIRPORT_LIST_REQUEST",
});

export const fetchJobOrderAirportListSuccess = (data) => ({
    type: "FIND_JOBORDER_AIRPORT_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderAirportListFailure = (error) => ({
    type: "FIND_JOBORDER_AIRPORT_LIST_FAILURE",
    payload: error,
});

export const getJobOrderAirportList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderAirportListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/airport/list`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderAirportListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderAirportList function (redux):", err);
                dispatch(fetchJobOrderAirportListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderAirportList function:", error);
            dispatch(fetchJobOrderAirportListFailure(error));
        }
    };
};

// job order airport

// job order seaport
export const fetchJobOrderSeaportListRequest = () => ({
    type: "FIND_JOBORDER_SEAPORT_LIST_REQUEST",
});

export const fetchJobOrderSeaportListSuccess = (data) => ({
    type: "FIND_JOBORDER_SEAPORT_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderSeaportListFailure = (error) => ({
    type: "FIND_JOBORDER_SEAPORT_LIST_FAILURE",
    payload: error,
});

export const getJobOrderSeaportList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderSeaportListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/seaport/list`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderSeaportListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderSeaportList function (redux):", err);
                dispatch(fetchJobOrderSeaportListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderSeaportList function:", error);
            dispatch(fetchJobOrderSeaportListFailure(error));
        }
    };
};

// job order seaport

// job order airline
export const fetchJobOrderAirlineListRequest = () => ({
    type: "FIND_JOBORDER_AIRLINE_LIST_REQUEST",
});

export const fetchJobOrderAirlineListSuccess = (data) => ({
    type: "FIND_JOBORDER_AIRLINE_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderAirlineListFailure = (error) => ({
    type: "FIND_JOBORDER_AIRLINE_LIST_FAILURE",
    payload: error,
});

export const getJobOrderAirlineList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderAirlineListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/airline/get`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderAirlineListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderAirlineList function (redux):", err);
                dispatch(fetchJobOrderAirlineListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderAirlineList function:", error);
            dispatch(fetchJobOrderAirlineListFailure(error));
        }
    };
};

// job order airline

// job order shipline
export const fetchJobOrderShiplineListRequest = () => ({
    type: "FIND_JOBORDER_SHIPLINE_LIST_REQUEST",
});

export const fetchJobOrderShiplineListSuccess = (data) => ({
    type: "FIND_JOBORDER_SHIPLINE_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderShiplineListFailure = (error) => ({
    type: "FIND_JOBORDER_SHIPLINE_LIST_FAILURE",
    payload: error,
});

export const getJobOrderShiplineList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderShiplineListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/shipline/get`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderShiplineListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderShiplineList function (redux):", err);
                dispatch(fetchJobOrderShiplineListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderShiplineList function:", error);
            dispatch(fetchJobOrderShiplineListFailure(error));
        }
    };
};

// job order shipline


// job order freight details
export const fetchJobOrderFreightDetailsRequest = () => ({
    type: "FIND_JOBORDER_FREIGHT_DETAIL_REQUEST",
});

export const fetchJobOrderFreightDetailsSuccess = (data) => ({
    type: "FIND_JOBORDER_FREIGHT_DETAIL_SUCCESS",
    payload: data,
});

export const fetchJobOrderFreightDetailsFailure = (error) => ({
    type: "FIND_JOBORDER_FREIGHT_DETAIL_FAILURE",
    payload: error,
});

export const getJobOrderFreightDetails = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderFreightDetailsRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/freight/details`;

        let body = { job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderFreightDetailsSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderFreightDetails function (redux):", err);
                dispatch(fetchJobOrderFreightDetailsFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderFreightDetails function:", error);
            dispatch(fetchJobOrderFreightDetailsFailure(error));
        }
    };
};

// job order freight details


// job order incoterm list
export const fetchJobOrderIncotermListRequest = () => ({
    type: "FIND_JOBORDER_INCOTERM_LIST_REQUEST",
});

export const fetchJobOrderIncotermListSuccess = (data) => ({
    type: "FIND_JOBORDER_INCOTERM_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderIncotermListFailure = (error) => ({
    type: "FIND_JOBORDER_INCOTERM_LIST_FAILURE",
    payload: error,
});

export const getJobOrderIncotermList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderIncotermListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/incoterms/get`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderIncotermListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderIncotermList function (redux):", err);
                dispatch(fetchJobOrderIncotermListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderIncotermList function:", error);
            dispatch(fetchJobOrderIncotermListFailure(error));
        }
    };
};

// job order incoterm list

// job order currency list
export const fetchJobOrderCurrencyListRequest = () => ({
    type: "FIND_JOBORDER_CURRENCY_LIST_REQUEST",
});

export const fetchJobOrderCurrencyListSuccess = (data) => ({
    type: "FIND_JOBORDER_CURRENCY_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderCurrencyListFailure = (error) => ({
    type: "FIND_JOBORDER_CURRENCY_LIST_FAILURE",
    payload: error,
});

export const getJobOrderCurrencyList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCurrencyListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderCurrencyListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderCurrencyList function (redux):", err);
                dispatch(fetchJobOrderCurrencyListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderCurrencyList function:", error);
            dispatch(fetchJobOrderCurrencyListFailure(error));
        }
    };
};

// job order incoterm list


// job order cfs list
export const fetchJobOrderCFSListRequest = () => ({
    type: "FIND_JOBORDER_CFS_LIST_REQUEST",
});

export const fetchJobOrderCFSListSuccess = (data) => ({
    type: "FIND_JOBORDER_CFS_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderCFSListFailure = (error) => ({
    type: "FIND_JOBORDER_CFS_LIST_FAILURE",
    payload: error,
});

export const getJobOrderCFSList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCFSListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderCFSListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderCFSList function (redux):", err);
                dispatch(fetchJobOrderCFSListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderCFSList function:", error);
            dispatch(fetchJobOrderCFSListFailure(error));
        }
    };
};

// job order cfs list

// job order transport pickup branch list
export const fetchJobOrderTransportPickupBranchListRequest = () => ({
    type: "FIND_JOBORDER_TRANSPORT_PICKUP_BRANCH_LIST_REQUEST",
});

export const fetchJobOrderTransportPickupBranchListSuccess = (data) => ({
    type: "FIND_JOBORDER_TRANSPORT_PICKUP_BRANCH_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderTransportPickupBranchListFailure = (error) => ({
    type: "FIND_JOBORDER_TRANSPORT_PICKUP_BRANCH_LIST_FAILURE",
    payload: error,
});

export const getJobOrderTransportPickupBranchList = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderTransportPickupBranchListRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/list`;

        let body = { customer_id: branch_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderTransportPickupBranchListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderTransportPickupBranchList function (redux):", err);
                dispatch(fetchJobOrderTransportPickupBranchListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderTransportPickupBranchList function:", error);
            dispatch(fetchJobOrderTransportPickupBranchListFailure(error));
        }
    };
};

// job order transport pickup branch list

// job order transport deliver branch list
export const fetchJobOrderTransportDeliverBranchListRequest = () => ({
    type: "FIND_JOBORDER_TRANSPORT_DELIVER_BRANCH_LIST_REQUEST",
});

export const fetchJobOrderTransportDeliverBranchListSuccess = (data) => ({
    type: "FIND_JOBORDER_TRANSPORT_DELIVER_BRANCH_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderTransportDeliverBranchListFailure = (error) => ({
    type: "FIND_JOBORDER_TRANSPORT_DELIVER_BRANCH_LIST_FAILURE",
    payload: error,
});

export const getJobOrderTransportDeliverBranchList = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderTransportDeliverBranchListRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/list`;

        let body = { customer_id: branch_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderTransportDeliverBranchListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderTransportDeliverBranchList function (redux):", err);
                dispatch(fetchJobOrderTransportDeliverBranchListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderTransportDeliverBranchList function:", error);
            dispatch(fetchJobOrderTransportDeliverBranchListFailure(error));
        }
    };
};

// job order transport deliver branch list

// job order transport transporter branch list
export const fetchJobOrderTransportTransporterBranchListRequest = () => ({
    type: "FIND_JOBORDER_TRANSPORT_TRANSPORTER_BRANCH_LIST_REQUEST",
});

export const fetchJobOrderTransportTransporterBranchListSuccess = (data) => ({
    type: "FIND_JOBORDER_TRANSPORT_TRANSPORTER_BRANCH_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderTransportTransporterBranchListFailure = (error) => ({
    type: "FIND_JOBORDER_TRANSPORT_TRANSPORTER_BRANCH_LIST_FAILURE",
    payload: error,
});

export const getJobOrderTransportTransporterBranchList = (token, user_id, branch_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderTransportTransporterBranchListRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/list`;

        let body = { customer_id: branch_id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderTransportTransporterBranchListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderTransportTransporterBranchList function (redux):", err);
                dispatch(fetchJobOrderTransportTransporterBranchListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderTransportTransporterBranchList function:", error);
            dispatch(fetchJobOrderTransportTransporterBranchListFailure(error));
        }
    };
};

// job order transport transporter branch list

// job order transport list
export const fetchJobOrderTransportListRequest = () => ({
    type: "FIND_JOBORDER_TRANSPORT_LIST_REQUEST",
});

export const fetchJobOrderTransportListSuccess = (data) => ({
    type: "FIND_JOBORDER_TRANSPORT_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderTransportListFailure = (error) => ({
    type: "FIND_JOBORDER_TRANSPORT_LIST_FAILURE",
    payload: error,
});

export const getJobOrderTransportList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderTransportListRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/transport/get`;

        let body = { job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderTransportListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderTransportList function (redux):", err);
                dispatch(fetchJobOrderTransportListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderTransportList function:", error);
            dispatch(fetchJobOrderTransportListFailure(error));
        }
    };
};

// job order transport list

// job order transport detail
export const fetchJobOrderTransportDetailRequest = () => ({
    type: "FIND_JOBORDER_TRANSPORT_DETAIL_REQUEST",
});

export const fetchJobOrderTransportDetailSuccess = (data) => ({
    type: "FIND_JOBORDER_TRANSPORT_DETAIL_SUCCESS",
    payload: data,
});

export const fetchJobOrderTransportDetailFailure = (error) => ({
    type: "FIND_JOBORDER_TRANSPORT_DETAIL_FAILURE",
    payload: error,
});

export const getJobOrderTransportDetail = (token, user_id, id, transport_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderTransportDetailRequest());
        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/jobOrder/transport/view`;

        let body = { id: transport_id, job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderTransportDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderTransportDetail function (redux):", err);
                dispatch(fetchJobOrderTransportDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderTransportDetail function:", error);
            dispatch(fetchJobOrderTransportDetailFailure(error));
        }
    };
};

// job order transport detail






// job order cargo list

export const fetchJobOrderCargoListRequest = () => ({
    type: "FIND_JOBORDER_CARGO_LIST_REQUEST",
});

export const fetchJobOrderCargoListSuccess = (data) => ({
    type: "FIND_JOBORDER_CARGO_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderCargoListFailure = (error) => ({
    type: "FIND_JOBORDER_CARGO_LIST_FAILURE",
    payload: error,
});

export const getJobOrderCargoList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCargoListRequest());
        const apiUrl = `${adminMainUrl}/api/jobOrder/cargo/get`;

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderCargoListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderList function (redux):", err);
                dispatch(fetchJobOrderCargoListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderList function:", error);
            dispatch(fetchJobOrderCargoListFailure(error));
        }
    };
};
// job order cargo list


// job order cargo list

export const fetchJobOrderCommodityListRequest = () => ({
    type: "FIND_JOBORDER_COMMODITY_LIST_REQUEST",
});

export const fetchJobOrderCommodityListSuccess = (data) => ({
    type: "FIND_JOBORDER_COMMODITY_LIST_SUCCESS",
    payload: data,
});

export const fetchJobOrderCommodityListFailure = (error) => ({
    type: "FIND_JOBORDER_COMMODITY_LIST_FAILURE",
    payload: error,
});

export const getJobOrderCommodityList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCommodityListRequest());
        const apiUrl = `${adminMainUrl}/api/commodity/get`;

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        // let body = { job_order_id: id }

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchJobOrderCommodityListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderList function (redux):", err);
                dispatch(fetchJobOrderCommodityListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderList function:", error);
            dispatch(fetchJobOrderCommodityListFailure(error));
        }
    };
};
// job order cargo list

// job order cargo list

export const fetchJobOrderCargoDetailRequest = () => ({
    type: "FIND_JOBORDER_CARGO_DETAIL_REQUEST",
});

export const fetchJobOrderCargoDetailSuccess = (data) => ({
    type: "FIND_JOBORDER_CARGO_DETAIL_SUCCESS",
    payload: data,
});

export const fetchJobOrderCargoDetailFailure = (error) => ({
    type: "FIND_JOBORDER_CARGO_DETAIL_FAILURE",
    payload: error,
});

export const getJobOrderCargoDetail = (token, user_id, id, cargo_id) => {
    return async function (dispatch) {
        dispatch(fetchJobOrderCargoDetailRequest());
        const apiUrl = `${adminMainUrl}/api/jobOrder/cargo/view`;

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        let body = { id: cargo_id, job_order_id: id }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch(fetchJobOrderCargoDetailSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getJobOrderList function (redux):", err);
                dispatch(fetchJobOrderCargoDetailFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getJobOrderList function:", error);
            dispatch(fetchJobOrderCargoDetailFailure(error));
        }
    };
};
// job order cargo list



//unused final Quotation with Pagination List
export const getUnusedFinalQuotationWithPaginationList = (token, user_id, page, search_text) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_UNUSED_FINAL_QUOTATION_WITH_PAGINATION_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/jobOrder/unused-final-quotation-with-pagination`;
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (search_text) queryParams.push(`search=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_UNUSED_FINAL_QUOTATION_WITH_PAGINATION_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getUnusedFinalQuotationWithPaginationList function (redux):", err);
                dispatch({
                    type: "FIND_UNUSED_FINAL_QUOTATION_WITH_PAGINATION_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getUnusedFinalQuotationWithPaginationList function:", error);
            dispatch({
                type: "FIND_UNUSED_FINAL_QUOTATION_WITH_PAGINATION_FAILURE",
                payload: error,
            });
        }
    };
};

export const getAllApprovedCustomers = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_JOB_ORDER_APPROVED_CUSTOMERS_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/jobOrder/get-all-approved-customers`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_JOB_ORDER_APPROVED_CUSTOMERS_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getAllApprovedCustomers function (redux):", err);
                dispatch({
                    type: "FIND_JOB_ORDER_APPROVED_CUSTOMERS_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getAllApprovedCustomers function:", error);
            dispatch({
                type: "FIND_JOB_ORDER_APPROVED_CUSTOMERS_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getCompanyBranch = (token, user_id, company_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_JOB_ORDER_COMPANY_BRANCH_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/jobOrder/get-company-branch`;
        let body = { company_id: company_id }
        try {
            axios.post(apiUrl,body, config).then((res) => {
                dispatch({
                    type: "FIND_JOB_ORDER_COMPANY_BRANCH_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCompanyBranch function (redux):", err);
                dispatch({
                    type: "FIND_JOB_ORDER_COMPANY_BRANCH_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCompanyBranch function:", error);
            dispatch({
                type: "FIND_JOB_ORDER_COMPANY_BRANCH_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getUnusedQuotationByCustomerList = (token, user_id, company_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_UNUSED_QUOTATION_BY_COMPANY_LIST_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/jobOrder/unused-final-quotation-by-company`;
        let body = { company_id: company_id }
        try {
            axios.post(apiUrl,body, config).then((res) => {
                dispatch({
                    type: "FIND_UNUSED_QUOTATION_BY_COMPANY_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getUnusedQuotationByCustomerList function (redux):", err);
                dispatch({
                    type: "FIND_UNUSED_QUOTATION_BY_COMPANY_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getUnusedQuotationByCustomerList function:", error);
            dispatch({
                type: "FIND_UNUSED_QUOTATION_BY_COMPANY_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

export const getFFDetailsByJobOrder = (token, user_id, job_order_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_FF_DETAILS_BY_JOBORDER_REQUEST",
        });

        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/jobOrder/get-job-order-ff-details`;
        let body = { job_order_id: job_order_id }
        try {
            axios.post(apiUrl,body, config).then((res) => {
                dispatch({
                    type: "FIND_FF_DETAILS_BY_JOBORDER_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getFFDetailsByJobOrder function (redux):", err);
                dispatch({
                    type: "FIND_FF_DETAILS_BY_JOBORDER_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getFFDetailsByJobOrder function:", error);
            dispatch({
                type: "FIND_FF_DETAILS_BY_JOBORDER_FAILURE",
                payload: error,
            });
        }
    };
};